/**
 * Openings (gap fill): Schedule > Openings, the schedule's holes as a call
 * worklist with who to call ranked and explained, what each fill is worth,
 * and the results. API `/v1/gap-fill` (apps/api modules/gap-fill). Home
 * shows today's openings (HomeOpenings.tsx). Nothing here texts or books by
 * itself: people call and book; an offer text is a draft sent from Messages.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'gap-fill',
    title: 'Openings',
    version: '0.1.0',
    owner: 'WP1-SCHED-PANELS',
    entitlementKey: null,
    permissions: ['schedule.view', 'schedule.edit', 'money.view'],
    routes: [
      {
        id: 'openings',
        path: '/schedule/openings',
        title: 'Openings',
        officeScope: 'location',
        permission: 'schedule.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Openings',
        group: 'schedule',
        routeId: 'openings',
        icon: 'list-checks',
        order: 14,
        permission: 'schedule.view',
      },
    ],
    commands: [
      {
        id: 'gap-fill.openings',
        title: 'Openings: fill open chair time',
        keywords: [
          'holes',
          'openings',
          'gaps',
          'fill',
          'cancellation',
          'short call',
          'quick fill',
          'asap',
          'who to call',
        ],
        routeId: 'openings',
        permission: 'schedule.view',
      },
    ],
    shortcuts: [],
    sseEntityKeys: [],
    phiReadPoints: ['gap_fill.candidates', 'gap_fill.board', 'gap_fill.home', 'gap_fill.analytics'],
  }),
  pages: {
    openings: () => import('./OpeningsPage.js'),
  },
});
